/**
 * Canonical left-to-right order of routes represented in the mobile bottom tab bar.
 * Used to pick slide direction (forward vs back) when switching tabs.
 */
export const MOBILE_TAB_ROUTE_ORDER = [
  "/",
  "/market",
  "/sell",
  "/my-stuff",
  "/profile",
] as const;

export type MobileTabRoute = (typeof MOBILE_TAB_ROUTE_ORDER)[number];

function normalizePathname(pathname: string): string {
  const path = pathname.split("?")[0] ?? pathname;
  if (path.length > 1 && path.endsWith("/")) {
    return path.slice(0, -1);
  }
  return path;
}

/**
 * Returns tab index for slide direction, or -1 if this screen is not under a tab route.
 */
export function getMobileTabRouteIndex(pathname: string): number {
  const path = normalizePathname(pathname);

  if (path === "/") {
    return 0;
  }

  for (let i = 1; i < MOBILE_TAB_ROUTE_ORDER.length; i += 1) {
    const tab = MOBILE_TAB_ROUTE_ORDER[i];
    if (path === tab || path.startsWith(`${tab}/`)) {
      return i;
    }
  }

  return -1;
}
